var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14 4.5V14a2 2 0 0 1-2 2h-2v-1h2a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v7H2V2a2 2 0 0 1 2-2h5.5L14 4.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.946 16v-6h1.657c.296 0 .573.034.83.103.259.066.493.16.704.284.184.102.349.227.492.375.147.146.274.305.382.478.126.212.223.445.29.7.07.256.106.528.106.817v.494c0 .278-.032.54-.097.788a2.793 2.793 0 0 1-.272.68 2.948 2.948 0 0 1-.391.51c-.15.154-.314.283-.493.388a2.66 2.66 0 0 1-.69.284 3.117 3.117 0 0 1-.8.099H4.947Zm1.244-5.06v4.129h.475c.152 0 .294-.018.426-.054a1.238 1.238 0 0 0 .66-.429 1.696 1.696 0 0 0 .35-.82c.03-.159.045-.33.045-.515v-.502a2.62 2.62 0 0 0-.163-.92 1.508 1.508 0 0 0-.255-.411 1.3 1.3 0 0 0-.712-.429 1.628 1.628 0 0 0-.413-.05H6.19ZM1.534 10l.606 2.254L2.83 10h1.534v6H3.23v-1.776l.053-2.806-.84 2.604h-.61l-.752-2.493.053 2.695V16H0v-6h1.534Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdFile);
export default __webpack_public_path__ + "static/media/md-file.edd82e3dc2d15cd8cb366a7765198fe8.svg";
export { ForwardRef as ReactComponent };